<!-- Body -->
<div class="ui basic segment">
    <app-header [title]="title | appTranslate" [back]="true"></app-header>
    <div class="ui layout">
        <div class="content">
            <div class="ui segment">
                <app-asset-form #assetForm [asset]="asset"></app-asset-form>
            </div>
            <div style="display: flex; justify-content: flex-end">
                <ui-button (click)="cancel($event)">{{ 'company.assets.cancel' | translate }} </ui-button>
                <ui-button (click)="save(assetForm)" type="primary">{{ 'company.assets.save' | translate }} </ui-button>
            </div>
        </div>

        <div class="sidebar">
            <div class="ui segment">
                <h3 class="text-color">{{ 'company.assets.assetTracking' | translate }}</h3>
                <p>{{ 'company.assets.assetTrackingHelpDescription' | translate }}</p>
                <p>
                    <a href="{{ '360052616033' | i18nHelpCentre }}" target="_blank"
                        >{{ 'company.assets.assetTrackingHelpLink' | translate }}
                    </a>
                </p>
            </div>
        </div>
    </div>
</div>
